import {
  createPortableDialog,
  usePortableDialog,
} from '@wwe-portal/ui/components/dialog';
import { RubiesIcon, WebCoinIcon } from '@wwe-portal/ui/components/icons';
import { ExchangeCalculatorDialog as ExchangeCalculatorDialogUI } from '@wwe-portal/ui/features/store-revamp/dialog/exchange-calculator-dialog';
import { useTranslations } from 'next-intl';

interface ExchangeCalculatorProps {
  toCurrency: string;
  rate: number;
}

const IcomComponents = {
  Ruby: RubiesIcon,
  'Web Coin': WebCoinIcon,
};

const Icon = ({ currency }: { currency: string }) => {
  const Component = IcomComponents[currency as keyof typeof IcomComponents];
  if (Component == null) return null;
  return <Component className="size-3" />;
};

export const ExchangeCalculatorPortable = createPortableDialog(
  ({ toCurrency, rate }: ExchangeCalculatorProps) => {
    const modal = usePortableDialog();
    const t = useTranslations();
    return (
      <ExchangeCalculatorDialogUI
        title={
          (
            <>
              {t('usd')} {t('to')} {t(`currency_${toCurrency}_plural`)}
            </>
          ) as never
        }
        description={
          <div>
            <strong>{t('information')}:</strong>
            <br />
            <div>{t(`shop_calculator_${toCurrency}_information_desc`)}</div>
          </div>
        }
        toCurrency={t(`currency_${toCurrency}_plural`)}
        toCurrencyIcon={<Icon currency={toCurrency} />}
        open={modal.visible}
        onClose={function (): void {
          modal.remove();
        }}
        rate={rate}
      />
    );
  }
);
